import '@operato/data-grist'
import '@operato/form'

import { css, html } from 'lit'
import { customElement, property, query, state } from 'lit/decorators.js'

import { PageView } from '@operato/shell'
import { i18next, localize } from '@operato/i18n'
import { CommonButtonStyles, ScrollbarStyles } from '@operato/styles'

@customElement('jasper-report-samples-crosstab-page')
class JasperReportSamplesCrosstabPage extends localize(i18next)(PageView) {
  static styles = [
    ScrollbarStyles,
    css`
      :host {
        display: flex;
        flex-direction: column;
        padding: 0;
      }

      #container {
        flex: 1;
        padding: 0;
        margin: 0;
        border: 0;
      }
    `
  ]

  @query('iframe') container!: HTMLIFrameElement

  get context() {
    const filters = [
      {
        name: 'workDateRange',
        type: 'date',
        label: 'date',
        operator: 'between'
      }
    ]
    var actions = [
      {
        title: i18next.t('button.print'),
        action: () => {
          this.container.contentWindow?.print()
        },
        ...CommonButtonStyles.print
      }
    ]
    return {
      title: 'jasper-report',
      actions,
      filters
    }
  }

  render() {
    return html`
      <ox-filters-form-base
        .filters=${this.context.filters}
        @filters-change=${e => {
          console.log('filters changed', e.detail)
          this._reportTemplate(e.detail.filters)
        }}
        ?url-params-sensitive=${this.active}
      ></ox-filters-form-base>
      <iframe id="container"></iframe>
    `
  }

  async pageUpdated(changes, lifecycle) {
    if (this.active) {
      this.updateContext()
    }
  }

  async _reportTemplate(filters) {
    const params = filters.reduce((acc, curr) => ((acc[curr.name] = curr.value), acc), {})
    Object.assign(params, this.lifecycle.params)

    const { workDateRange, workShift, template } = params

    /** ignoring date conditions  */
    if (!workDateRange[0] || !workDateRange[1] || workDateRange[0] > workDateRange[1]) {
      return
    }

    /** urlencoded params including test values */
    const urlParams = {
      table: 'samples',
      dataSetId: this.lifecycle.resourceId,
      fromWorkDate: workDateRange[0],
      toWorkDate: workDateRange[1],
      workShift,
      template,
      templateType: 'crosstab'
    }

    const encodedUrlParams = Object.keys(urlParams)
      .filter(key => {
        // ignore empty
        return !!urlParams[key]
      })
      .map(key => `${key}=${encodeURIComponent(urlParams[key])}`)
      .join('&')

    this.container.src = `/data-report/jasper?${encodedUrlParams}`
  }
}
